import {
  ColumnFiltersState,
  PaginationState,
  SortingState,
} from '@tanstack/react-table'
import { z } from 'zod'

export enum DocumentViewerPage {
  LEFT_PAGE = 0,
  RIGHT_PAGE = 1,
}

export type SearchMode = 'keyword' | 'semantic'

export const documentsSearchSchema = z.object({
  documentID: z.string().optional(),
  pageNumber: z.number().optional(),
  selectedBoxes: z.array(z.string()).optional(),
})

export type DocumentsSearchParams = z.infer<typeof documentsSearchSchema>

export interface SearchHistoryItem {
  type: 'search'
  searchState: {
    searchMode: SearchMode
    query: string
    semanticQuery: string
    filters: ColumnFiltersState
    sorting: SortingState
    pagination: PaginationState
    selectedDocumentId: string | null
    isPreviewOpen: boolean
  }
  // when set, this is a scoped search showing only linked documents
  linkedDocuments?: {
    referenceText: string
    documentIds: string[]
  }
}

export interface DocumentHistoryItem {
  type: 'document'
  documentId: string
  pageNumber: number
  selectedBoxIds: string[]
  query: string
}

export type TabHistoryItem = SearchHistoryItem | DocumentHistoryItem

export interface DocumentTab {
  id: string
  history: TabHistoryItem[]
  currentIndex: number
}
